module.exports = __webpack_public_path__ + "img/wordpress-white.6a46c79a.png";